import { createAction, ActionType } from 'typesafe-actions';

export const openSideMenu = createAction('OPEN_SIDE_MENU', () => {})();
export const closeSideMenu = createAction('CLOSE_SIDE_MENU', () => {})();

export type SideMenuActionTypes = ActionType<typeof openSideMenu | typeof closeSideMenu>;
